// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__7qfnK","title":"style_title__uc8UU"};